<template>
  <div class="k-directory-access">
    <Icon icon="fa-pro-light:key" class="k-directory-access__icon" />
    <div
      :class="['k-directory-access__item', { 'k-directory-access__item--selected': !value.length }]"
      @click="$emit('input')"
    >
      {{ $t('all', { x: '' }) }}
    </div>
    <div
      v-for="group in groups"
      :class="[
        'k-directory-access__item',
        { 'k-directory-access__item--selected': value.includes(group.value) },
      ]"
      @click="() => $emit('input', group.value)"
    >
      {{ group.label }}
    </div>
  </div>
</template>

<script>
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: { type: Array, default: () => [] },
    groups: Array,
  },
  methods: {
    transform(group) {
      return `acl:${group.value}`
    },
    toggle(group) {
      if (this.value.includes(group.value))
        return this.$emit(
          'input',
          this.value.filter(v => v !== group.value),
        )

      if (this.value.length === this.groups.length - 1) return this.$emit('input', [])
      return this.$emit('input', [...this.value, group.value])
    },
  },
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.k-directory-access {
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  background-color: #f9f9f9;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 3px;

  &__icon {
    margin: 0 0.5em;
  }

  &__item {
    padding: 0.3em 0.6em 0.35em 0.6em;
    border-radius: var(--border-radius);
    border: 1px solid transparent;

    &--selected {
      background-color: #555;
      border-color: darken(#555, 10%);
      color: white;
    }
  }
}
</style>
